module.exports = __webpack_public_path__ + "static/media/NI.05410434.png";